/* istanbul ignore file */
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';
import { DocuSignEnvelopeStatus, DocuSignEnvelopeStatusAlias } from '../docusignStatus';

const DocuSignEnvelopeStatusBadge = ({ value: inputValue, source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });
  const value = inputValue || getValue();
  const displayText = DocuSignEnvelopeStatusAlias[value];

  const getColor = () => {
    let result: BasicColors = 'info';
    if (value === DocuSignEnvelopeStatus.COMPLETED) {
      result = 'success';
    } else if (value === DocuSignEnvelopeStatus.VOIDED) {
      result = 'warning';
    } else if (value === DocuSignEnvelopeStatus.DECLINED) {
      result = 'error';
    }

    return result;
  };

  return <CustomBadge text={displayText} color={getColor()} {...props} />;
};

export default DocuSignEnvelopeStatusBadge;
